import React, {useEffect, useState} from "react";
import {PageHeader} from "../../../components/PageHeader";
import {IncidentListType} from "./subPages/IncidentListType";
import useRequestData from "../../../hooks/useRequestData";
import {isMobile, toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import {getIncidentList} from "../../../api/maintenance/IncidentService";
import MaintenanceListThumbType from "../MaintenanceListThumbType";
import MobileCreateButton from "../../../components/buttons/MobileCreateButton";
import {CHART_REGISTRY} from "../../../components/AiComponents/ChartRegistry";

function IncidentList() {
    const [checked,setChecked] = useState([]);

    const initDate ={
        startDate:toKSTISOString(addYears(new Date(),-1)),
        endDate:toKSTISOStringEnd(addYears(new Date(),0)),
    }

    const { data, newData, pageInfo, dataHook} =
        useRequestData(getIncidentList, initDate, "incident");

    const [listType, setListType] = useState(true)
    useEffect(() => {
        if (isMobile) {
            // mobile
            setListType(false);
        }
    }, []);

    return (
        <>
            <div className="common-container">
                <PageHeader header={"장애등록관리"} indicator={`유지보수업무 > 장애관리 > 장애등록관리`} keys={CHART_REGISTRY.incident.key} />

                { listType ?
                    <IncidentListType
                        data={newData} date={initDate} pageInfo={pageInfo} dataHook={dataHook}
                        checked={{checked: checked, setChecked: setChecked}} />
                    :
                    <MaintenanceListThumbType data={data} date={initDate} pageInfo={pageInfo} dataHook={dataHook} type={"incident"} />
                }

                <MobileCreateButton  url={'/maintenance/incident/create'} assetCheck />
            </div>
        </>
    );
}

export {IncidentList}